/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { toAbsoluteUrl } from '../../../helpers'
import Swal from 'sweetalert2'
import { Languages } from './Languages'
import { Tr } from '../../../i18n/Tr'
import { clearCookies } from '../../../assets/ts/components/CookieComponent'

const HeaderUserMenu: FC = () => {
  let t = Tr()

  const { currentUser, logout } = useAuth()
  const [admindata, setadminData] = useState(Object)

  const confirmlogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You Want To Sign Out',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {
        window.location.reload()
        sessionStorage.removeItem('admin')
        clearCookies()
      }
    })
  }
  useEffect(() => {
    var tmp: any = sessionStorage.getItem('admin')
    tmp = JSON.parse(tmp)

    setadminData(tmp)
  }, [admindata])

  const location = useLocation()

  useEffect(() => {
    if (
      sessionStorage.getItem('locationVendorId') &&
      location.pathname != '/viewvendor/vendordetail/personaldetail'
    ) {
      sessionStorage.removeItem('locationVendorId')
    }
  }, [])

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
      id='kt_header_user_menu'

      data-popper-placement='bottom-start'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img
              alt='Logo'
              src={admindata ? admindata['profilePicture'] : toAbsoluteUrl('/media/default.jpg')}
            />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {admindata ? admindata['fullName'] : ''}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                {t('Admin')}
              </span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-success fs-7'>
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          {t('My Profile')}
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={confirmlogout} className='menu-link px-5'>
          {t('Sign Out')}
        </a>
      </div>

      <Languages />
    </div>
  )
}

export { HeaderUserMenu }
